import React, { ReactElement } from "react";
import classnames from "classnames";

interface ModalBodyProps {
  className?: string;
  children: ReactElement | ReactElement[];
}

export const ModalBody = ({ children, className }: ModalBodyProps) => (
  <div className={classnames("modal__body", className)}>{children}</div>
);
